import { authRequest } from './auth';

const getUserProfile = async () => {
    return authRequest.get('/users/me/')
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(error));
}

export { getUserProfile };